__turbopack_context__.v({
  "button": "styles-module-scss-module__X-7hxW__button",
  "buttonGroup": "styles-module-scss-module__X-7hxW__buttonGroup",
  "content": "styles-module-scss-module__X-7hxW__content",
  "dark": "styles-module-scss-module__X-7hxW__dark",
  "fullWidth": "styles-module-scss-module__X-7hxW__fullWidth",
  "loader": "styles-module-scss-module__X-7hxW__loader",
  "loading": "styles-module-scss-module__X-7hxW__loading",
  "spin": "styles-module-scss-module__X-7hxW__spin",
});
